import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "antd";
import S from "string";
import { renderField } from "utils/forms";

const fields = ["email", "password"];
const validate = values => {
  const errors = {};

  fields.forEach(function(field) {
    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }
  });

  return errors;
};

let ForgotPasswordForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row type="flex" justify="center" align="middle">
        <Col md={8} xs={20}>
          <Field
            label="Email"
            name="email"
            component={renderField}
            type="email"
          />
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col md={6} xs={20}>
          <Button
            style={{
              width: "100%"
            }}
            type="primary"
            htmlType="submit"
          >
            Request Password Reset
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "login",
  validate
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/auth/forms/forgot-password.js